import { AppTemplateVersion } from "src/models/appTemplate";
import { createEntityModel } from "src/store/models/entity/_shared";

export const AppTemplateVersionEntityModel =
  createEntityModel<AppTemplateVersion>();
